import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, CalloutBlockData } from '../../../../models';
import { CalloutNodeView } from './CalloutNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    calloutNode: { insertCalloutNode: ({ text, icon }: CalloutBlockData) => ReturnType };
  }
}

export const CalloutNode = Node.create({
  name: 'calloutNode',
  group: 'block',
  content: 'inline*',

  addAttributes() {
    return { text: '', icon: '' };
  },

  parseHTML() {
    return [{ tag: BlockTypes.callout }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.callout, mergeAttributes(HTMLAttributes), 0];
  },

  addCommands() {
    return {
      insertCalloutNode:
        ({ text, icon }: CalloutBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { text, icon } });
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { $from } = editor.state.selection;

        if ($from.node($from.depth).type.name === this.name) {
          return editor.chain().setHardBreak().run();
        }

        return false;
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(CalloutNodeView);
  },
});
